export default __webpack_public_path__ + "static/media/toeSideWalkThumb.c48f4c5c.png";